import { Component } from '@theme/component';
import { ProductSelectEvent, StandardEvents } from '@shopify/events';

/**
 * Keeps Product Bento Grid content synchronized with the selected variant.
 * VariantPicker already fetches the updated product HTML, so this component
 * consumes that response instead of making another request.
 */
class ProductCalloutBentoComponent extends Component {
  #controller = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }

  /** @param {ProductSelectEvent} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    const sourcePicker = event.target.closest('variant-picker');
    if (sourcePicker?.dataset.productId !== this.dataset.productId) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (detail.productId && detail.productId !== this.dataset.productId) return;

        const replacement = Array.from(
          detail.html.querySelectorAll('product-callout-bento-component[data-block-id]')
        ).find((candidate) => candidate.dataset.blockId === this.dataset.blockId);

        if (replacement) this.replaceWith(replacement);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-callout-bento] Variant update failed:', error);
      });
  };
}

if (!customElements.get('product-callout-bento-component')) {
  customElements.define('product-callout-bento-component', ProductCalloutBentoComponent);
}
